import { adminV2PurchaseProofProgramSettings } from "@api/all";
import { withPermission } from "@components/WithAccessControl";
import React from "react";
import { json, useLoaderData, useParams } from "react-router-dom";

import { SettingsCard } from "../(components)/SettingsCard";

export const loader = async ({ params }) => {
  const { program_id } = params;
  const settings = await adminV2PurchaseProofProgramSettings.show({
    program_id: program_id,
  });

  return json(settings);
};

function PurchaseProofProgramSettings() {
  const { program_id } = useParams();
  // @ts-expect-error TS(2339) FIXME: Property 'data' does not exist on type '{}'.
  const { exclusion_identifiers, external_purchase_item_points_per_cents } =
    useLoaderData();

  const fields = [
    {
      name: "exclusion_identifiers",
      type: "input",
      label: "Exclusion Identifiers",
      description:
        "Excludes unrelated products and potential false positives for every product configured. Can be comma separated values.",
    },
    {
      name: "external_purchase_item_points_per_cents",
      type: "input",
      label: "External Purchase Item Points Per Cents",
      description:
        "The number of points per dollar for external purchase items.",
    },
    {
      name: "_method",
      type: "hidden",
      value: "patch",
    },
    {
      name: "program_id",
      type: "hidden",
      value: program_id,
    },
  ];

  return (
    <>
      <div className="my-8 space-y-4">
        <SettingsCard
          defaultValues={{
            exclusion_identifiers,
            external_purchase_item_points_per_cents,
            program_id,
          }}
          fields={fields}
          title={"Purchase Proof Settings"}
          action={{
            path: adminV2PurchaseProofProgramSettings.update.path({
              program_id,
            }),
          }}
          useFormSubmit
        />
      </div>
    </>
  );
}

export default withPermission(
  PurchaseProofProgramSettings,
  "program",
  "update",
);
